export default __webpack_public_path__ + "static/media/Benefit.7b593b8d.png";